export default {
  back: 'Back',
  before: 'Before',
  blast_radius: 'Blast Radius'
}
